import { AppRoute } from '@app/core/routing/AppRoute';
import { Switch, useRouteMatch } from 'react-router-dom';
import { AdminStationsEditPageWrapper } from './AdminStationsEditPageWrapper';
import { AdminStationsListPage } from './list/AdminStationsListPage';
import { AdminStationsViewPage } from './view/AdminStationsViewPage';

export function AdminStationsRoutes() {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <AppRoute path={`${path}/:slug/edit`} component={AdminStationsEditPageWrapper} />
      <AppRoute path={`${path}/:slug`} component={AdminStationsViewPage} />
      <AppRoute path={path} component={AdminStationsListPage} />
    </Switch>
  );
}
